import React from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

// Higher-order component to replace withRouter
export const withRouter = (Component) => {
    const WrappedComponent = (props) => {
        const location = useLocation()
        const navigate = useNavigate()
        const params = useParams()

        return (
            <Component
                {...props}
                location={location}
                navigate={navigate}
                params={params}
                history={{
                    push: navigate,
                    replace: (path) => navigate(path, { replace: true }),
                    goBack: () => navigate(-1),
                    goForward: () => navigate(1),
                }}
                match={{
                    params: params,
                    path: location.pathname,
                    url: location.pathname,
                }}
            />
        )
    }

    WrappedComponent.displayName = `withRouter(${Component.displayName || Component.name})`
    return WrappedComponent
}

export default withRouter
